import React from 'react'

export interface ChevronLeftIconProps {
  color?: string
  size?: number
  style?: React.CSSProperties
}

export function ChevronLeftIcon({
  color = '#0D6797',
  size = 1,
  ...rest
}: ChevronLeftIconProps) {
  return (
    <svg
      fill="none"
      height={10 * size}
      viewBox="0 0 6 10"
      width={6 * size}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M5 9L1 5L5 1"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  )
}

export default ChevronLeftIcon
